<template>
  <div v-if="isLoading" class="d-flex justify-center align-center">
    <v-row no-gutters class="px-12 py-6">
      <v-col cols="12" class="d-flex justify-center align-center">
        <v-progress-circular
          indeterminate
          color="#2661FF"
          size="80"
        ></v-progress-circular>
      </v-col>
    </v-row>
  </div>
  <div v-else>
    <v-card class="rounded-lg" flat>
      <v-card-title class="px-10 pt-8">
        <p>{{ $t('organization.details.tabs.integrations.title') }}</p>
      </v-card-title>
      <v-card-text>
        <v-list>
          <template>
            <div v-for="(item, index) of selectedIntegrations" :key="index">
              <v-divider />
              <v-list-item class="my-2">
                <v-list-item-content class="ml-2">
                  <v-list-item-title>
                    {{ formatOrganizationName(item.name) }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="mx-4">
                  <v-row :class="item.config ? 'mt-1' : ''">
                    <v-col cols="6" :class="!item.config ? 'mr-15' : ''">
                      <v-switch
                        v-model="item.enabled"
                        :value="item.enabled"
                        :disabled="item.disabled"
                        :readonly="isUpdateLoading"
                        color="#2661FF"
                        @change="integrationDialog(item.id)"
                      ></v-switch>
                    </v-col>
                    <v-col cols="6" v-if="item.config">
                      <v-btn
                        icon
                        color="grey"
                        class="pb-2 text--darken-3"
                        :disabled="!item.enabled"
                        @click="dispatchMethod(item.configDispatch)"
                      >
                        <v-icon size="28">
                          edit_square
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-list-item-action>
              </v-list-item>
            </div>
          </template>
        </v-list>
      </v-card-text>
    </v-card>
    <BaseConfirmDialog
      v-if="dialog"
      :cancel-text="$t('general.cancel')"
      :accept-text="$t('general.confirm')"
      @close="cancel()"
      @proceed="toggleIntegration()"
      :title="$t('organization.details.tabs.integrations.update_dialog.title')"
      :description="
        $t('organization.details.tabs.integrations.update_dialog.description')
      "
      :accept-loading="isUpdateLoading"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import BaseConfirmDialog from '@/components/BaseConfirmDialog.vue'

export default {
  name: 'organizationIntegrations',
  components: { BaseConfirmDialog },
  data() {
    return {
      isLoading: false,
      isUpdateLoading: false,
      integrationsLocal: [],
      selectedIntegrations: [],
      dialog: false,
      integration_id: null
    }
  },
  async created() {
    try {
      this.isLoading = true
      await this.getOrganizationIntegrations(this.organization.id)
      this.selectedIntegrations = JSON.parse(
        JSON.stringify(this.orgIntegrations)
      )
    } catch (error) {
      this.$noty.error(this.$t('organization.details.tabs.integrations.error'))
    } finally {
      this.isLoading = false
    }
  },
  computed: {
    ...mapState({
      organization: ({ organization: { organization } }) => organization,
      integrations: ({ organization: { integrations } }) => integrations,
      orgIntegrations: ({ organization: { orgIntegrations } }) =>
        orgIntegrations,
      isWhatsappConfigOpen: ({ accounts: { isWhatsappConfigOpen } }) =>
        isWhatsappConfigOpen
    })
  },
  methods: {
    ...mapActions({
      getOrganizationIntegrations: 'organization/getOrganizationIntegrations',
      updateOrganizationIntegrations:
        'organization/updateOrganizationIntegrations'
    }),
    ...mapMutations({
      setType: 'accounts/setType',
      toggleAmazonSESConfig: 'accounts/toggleAmazonSESConfig',
      toggleAmazonSESv2Config: 'accounts/toggleAmazonSESv2Config',
      toggleWhatsappConfig: 'accounts/toggleWhatsappConfig',
      setOrganizationIntegrations: 'organization/setOrganizationIntegrations'
    }),
    dispatchMethod(dispatch) {
      const { name, value } = dispatch
      this[name](value)
    },
    openAmazonSESConfig(type) {
      this.setType(type)
      this.toggleAmazonSESConfig(true)
    },
    openAmazonSESv2Config() {
      this.toggleAmazonSESv2Config(true)
    },
    openWhatsappConfig() {
      this.toggleWhatsappConfig(true)
    },
    async integrationDialog(id) {
      this.integration_id = id
      this.dialog = true
    },

    async cancel() {
      this.dialog = false
      this.selectedIntegrations = JSON.parse(
        JSON.stringify(this.orgIntegrations)
      )
    },
    async toggleIntegration() {
      this.isUpdateLoading = true
      try {
        const response = (
          await this.updateOrganizationIntegrations({
            id: this.organization.id,
            body: {
              integration_id: this.integration_id
            }
          })
        ).data
        if (response.success) {
          this.$noty.success(
            this.$t('organization.details.tabs.integrations.success')
          )
        } else {
          this.$noty.error(
            this.$t('organization.details.tabs.integrations.error')
          )
        }
      } catch (error) {
        this.selectedIntegrations = JSON.parse(
          JSON.stringify(this.orgIntegrations)
        )
        this.$noty.error(
          this.$t('organization.details.tabs.integrations.error')
        )
      } finally {
        this.isUpdateLoading = false
        this.dialog = false
      }
    },
    formatOrganizationName(integration) {
      const mappedIntegrations = {
        AmazonSES: 'Amazon SES',
        AmazonSESv2: 'Amazon SES v2',
        FacebookLeads: 'Facebook Leads'
      }

      return mappedIntegrations[integration] || integration
    }
  }
}
</script>

<style lang="scss" scoped></style>
